(<template>
    <div class="list" id="companies-list">
      <h1 v-translate>Partner companies</h1>
      <div class="create-button-container">
        <el-button v-if="$session.exists() && $route.path !=='/'"
                   id="button-add-partner-company"
                   type="primary"
                   icon="el-icon-plus"
                   @click="$router.push('/companies/create')"></el-button>
      </div>
      <div v-if="companiesList.length > 0">
        <el-table v-if="companiesList"
                  id="companies-table"
                  :data="companiesListPage"
                  height="100%">
          <el-table-column class="companies-table-column">
            <template slot-scope="companies">
              <div class="companies-list-flex-container">
                <div class="companies-list-thumbnail">
                  <img :src="companies.row.thumbnailName"/>
                </div>
                <div class="companies-list-content">
                    <strong><translate>Name</translate>:</strong>&nbsp;
                    {{companies.row.name}}<br/>
                     <strong><translate>Category</translate>:</strong>&nbsp;
                    {{companies.row.category}}<br/>
                    <strong><translate>Address</translate>:</strong>&nbsp;
                    {{companies.row.address}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="companies">
              <el-button v-if="$session.exists() && $route.path !=='/'"
                         id="button-edit"
                         icon="el-icon-edit"
                         @click="edit(companies.row.id)"></el-button>
              <el-button v-if="$session.exists() && $route.path !=='/'"
                         id="button-delete"
                         type="danger" icon="el-icon-delete"
                         @click="remove(companies.row.id)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <br />
        <el-pagination background
                       layout="prev, pager, next"
                       :total="companiesList.length"
                       :current-page.sync="currentPage"
                       :page-size="pageSize"
                       @current-change="changePage">
        </el-pagination>
        <el-dialog v-if="$session.exists() && isEditVisible"
                   :before-close="handleClose"
                   :visible.sync="isEditVisible">
          <companies-upload-form :loaded-form="companies"
                                @close-edit="closeEdit"
                                preview></companies-upload-form>
        </el-dialog>
      </div>
    </div>
  </template>)
  
  (<script>
  import axios from 'axios'
  import companiesUploadForm from './Partner-Companies-Upload-Form.vue'
  
  export default {
    name: 'companies-list',
    data () {
      var menuItems = {
        images: 'images'
      }
      return {
        menuItems,
        activeMenuImagesOrMap: menuItems.images,
        isEditVisible: false,
        companiesList: [],
        currentPage: 1,
        pageSize: 10,
        companiesListPage: []
      }
    },
    created () {
      this.getcompaniesList()
    },
    components: {
      'companies-upload-form': companiesUploadForm
    },
    methods: {
      changePage () {
        this.companiesListPage = this.companiesList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      },
      getcompaniesList () {
        axios({
          method: 'get',
          url: `${process.env.SERVER_URL}/companies?lang=${this.$language.current}`,
          withCredentials: true
        })
        .then(response => {
          this.companiesList = response.data
          this.companiesListPage = this.companiesList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
        })
      },
      getCompanies (id, callback) {
        axios({
          method: 'get',
          url: `${process.env.SERVER_URL}/companies/${id}`,
          withCredentials: true
        })
        .then(response => {
          this.companies = response.data
          callback(null)
        })
        .catch(error => {
          var msg
          if (error.response) {
            msg = error.response.data || error.response.statusText
          } else {
            msg = error.message
          }
          this.$message({
            type: 'error',
            message: msg
          })
          callback(error)
        })
      },
      handleClose (done) {
        this.$confirm(this.$gettext('Are you sure to close?'), {
          confirmButtonText: this.$gettext('Yes'),
          cancelButtonText: this.$gettext('No'),
          type: 'warning'
        }).then(() => {
          done()
        }).catch(() => {})
      },
      edit (id) {
        this.getCompanies(id, error => {
          if (!error) {
            this.isEditVisible = true
          }
        })
      },
      closeEdit () {
        this.isEditVisible = false
        this.getcompaniesList()
      },
      remove (id) {
        this.$confirm(this.$gettext('Are you sure to delete the partner company?'), {
          confirmButtonText: this.$gettext('Yes'),
          cancelButtonText: this.$gettext('No'),
          type: 'warning'
        }).then(() => {
          axios({
            method: 'delete',
            url: `${process.env.SERVER_URL}/companies/${id}`,
            withCredentials: true
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: this.$gettext('Delete has completed')
            })
            this.getcompaniesList()
          })
          .catch(error => {
            var msg
            if (error.response) {
              msg = error.response.data || error.response.statusText
            } else {
              msg = error.message
            }
            this.$message({
              type: 'error',
              message: msg
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$gettext('Delete has canceled')
          })
        })
      }
    }
  }
  </script>)
  
  (<style>
  #companies-table {
    height: 45em;
    overflow: hidden;
  }
  .el-table__body-wrapper {
    overflow-x: hidden;
  }
  .create-button-container {
    text-align: right;
  }
  .el-table td div {
    height: 0%;
  }
  .companies-list-flex-container {
    height: 7em;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
  }
  .companies-list-content {
    margin: auto;
    width: 60%;
    text-align: center;
  }
  .companies-list-thumbnail {
    width: 40%;
    margin: auto;
    height: 80%;
    text-align: center;
  }
  .companies-list-thumbnail > img {
    height: 100%;
    max-width: 150px;
  }
  .preview {
    padding: 5%;
    padding-top: 1%;
    text-align: left;
    max-height: 40em;
    overflow-y: scroll;
    scroll-behavior: smooth;
    line-height: 1em;
  }
  @media screen and (max-width: 1300px) {
    .companies-list-flex-container {
      flex-direction: column;
      height: 10em;
    }
    .companies-list-thumbnail {
      height: 60%;
    }
  }
  </style>)
  


// WEBPACK FOOTER //
// src/components/Partner-Companies-List-View.vue